import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { ReceivedDocumentsFilters } from "../hooks/useReceivedDocuments";

interface ReceivedDocumentFiltersProps {
  filters: ReceivedDocumentsFilters;
  onFilterChange: (key: string, value: string) => void;
}

export function ReceivedDocumentFilters({
  filters,
  onFilterChange,
}: ReceivedDocumentFiltersProps) {
  return (
    <div className="flex flex-wrap gap-4 mb-6">
      {/* Search */}
      <Input
        placeholder="Buscar por RUT o nombre..."
        value={filters.search ?? ""}
        onChange={(e) => onFilterChange("search", e.target.value)}
        className="w-64"
      />

      {/* Status filter */}
      <Select
        value={filters.status ?? "all"}
        onValueChange={(value) =>
          onFilterChange("status", value === "all" ? "" : value)
        }
      >
        <SelectTrigger className="w-40">
          <SelectValue placeholder="Estado" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos</SelectItem>
          <SelectItem value="pending">Pendiente</SelectItem>
          <SelectItem value="accepted">Aceptado</SelectItem>
          <SelectItem value="rejected">Rechazado</SelectItem>
        </SelectContent>
      </Select>

      {/* Document type filter */}
      <Select
        value={filters.documentTypeCode ?? "all"}
        onValueChange={(value) =>
          onFilterChange("documentTypeCode", value === "all" ? "" : value)
        }
      >
        <SelectTrigger className="w-48">
          <SelectValue placeholder="Tipo" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos los tipos</SelectItem>
          <SelectItem value="33">Factura Electrónica</SelectItem>
          <SelectItem value="34">Factura Exenta</SelectItem>
          <SelectItem value="52">Guía de Despacho</SelectItem>
          <SelectItem value="56">Nota de Débito</SelectItem>
          <SelectItem value="61">Nota de Crédito</SelectItem>
        </SelectContent>
      </Select>

      {/* Date from */}
      <Input
        type="date"
        value={filters.dateFrom ?? ""}
        onChange={(e) => onFilterChange("dateFrom", e.target.value)}
        className="w-40"
        placeholder="Desde"
      />

      {/* Date to */}
      <Input
        type="date"
        value={filters.dateTo ?? ""}
        onChange={(e) => onFilterChange("dateTo", e.target.value)}
        className="w-40"
        placeholder="Hasta"
      />
    </div>
  );
}
